/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { StatAggregateDataPoint } from './StatAggregateDataPoint';
import {
    StatAggregateDataPointFromJSON,
    StatAggregateDataPointFromJSONTyped,
    StatAggregateDataPointToJSON,
    StatAggregateDataPointToJSONTyped,
} from './StatAggregateDataPoint';

/**
 * 
 * @export
 * @interface StatsBillingGetResponse
 */
export interface StatsBillingGetResponse {
    /**
     * 
     * @type {Array<StatAggregateDataPoint>}
     * @memberof StatsBillingGetResponse
     */
    billable_persons?: Array<StatAggregateDataPoint>;
    /**
     * 
     * @type {number}
     * @memberof StatsBillingGetResponse
     */
    billable_persons_total?: number;
    /**
     * 
     * @type {Array<StatAggregateDataPoint>}
     * @memberof StatsBillingGetResponse
     */
    user_identities?: Array<StatAggregateDataPoint>;
    /**
     * 
     * @type {number}
     * @memberof StatsBillingGetResponse
     */
    user_identities_total?: number;
    /**
     * 
     * @type {Array<StatAggregateDataPoint>}
     * @memberof StatsBillingGetResponse
     */
    non_human_identities?: Array<StatAggregateDataPoint>;
    /**
     * 
     * @type {number}
     * @memberof StatsBillingGetResponse
     */
    non_human_identities_total?: number;
    /**
     * 
     * @type {Array<StatAggregateDataPoint>}
     * @memberof StatsBillingGetResponse
     */
    credentials?: Array<StatAggregateDataPoint>;
    /**
     * 
     * @type {number}
     * @memberof StatsBillingGetResponse
     */
    credentials_total?: number;
}

/**
 * Check if a given object implements the StatsBillingGetResponse interface.
 */
export function instanceOfStatsBillingGetResponse(value: object): value is StatsBillingGetResponse {
    return true;
}

export function StatsBillingGetResponseFromJSON(json: any): StatsBillingGetResponse {
    return StatsBillingGetResponseFromJSONTyped(json, false);
}

export function StatsBillingGetResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): StatsBillingGetResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'billable_persons': json['billable_persons'] == null ? undefined : ((json['billable_persons'] as Array<any>).map(StatAggregateDataPointFromJSON)),
        'billable_persons_total': json['billable_persons_total'] == null ? undefined : json['billable_persons_total'],
        'user_identities': json['user_identities'] == null ? undefined : ((json['user_identities'] as Array<any>).map(StatAggregateDataPointFromJSON)),
        'user_identities_total': json['user_identities_total'] == null ? undefined : json['user_identities_total'],
        'non_human_identities': json['non_human_identities'] == null ? undefined : ((json['non_human_identities'] as Array<any>).map(StatAggregateDataPointFromJSON)),
        'non_human_identities_total': json['non_human_identities_total'] == null ? undefined : json['non_human_identities_total'],
        'credentials': json['credentials'] == null ? undefined : ((json['credentials'] as Array<any>).map(StatAggregateDataPointFromJSON)),
        'credentials_total': json['credentials_total'] == null ? undefined : json['credentials_total'],
    };
}

export function StatsBillingGetResponseToJSON(json: any): StatsBillingGetResponse {
    return StatsBillingGetResponseToJSONTyped(json, false);
}

export function StatsBillingGetResponseToJSONTyped(value?: StatsBillingGetResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'billable_persons': value['billable_persons'] == null ? undefined : ((value['billable_persons'] as Array<any>).map(StatAggregateDataPointToJSON)),
        'billable_persons_total': value['billable_persons_total'],
        'user_identities': value['user_identities'] == null ? undefined : ((value['user_identities'] as Array<any>).map(StatAggregateDataPointToJSON)),
        'user_identities_total': value['user_identities_total'],
        'non_human_identities': value['non_human_identities'] == null ? undefined : ((value['non_human_identities'] as Array<any>).map(StatAggregateDataPointToJSON)),
        'non_human_identities_total': value['non_human_identities_total'],
        'credentials': value['credentials'] == null ? undefined : ((value['credentials'] as Array<any>).map(StatAggregateDataPointToJSON)),
        'credentials_total': value['credentials_total'],
    };
}

